import type { SxProps, Theme } from '@mui/material/styles';

// Markdown with images from the API (recipe descriptions)
export const markdownBody = {
    overflow: 'hidden',
    '& img': {
        maxWidth: '100%',
    },
} satisfies SxProps<Theme>;
